<template lang="html">
  <PageHeader />
  <section class="confirm-email account-section mt-stickybar mb-5 home">
    <div class="account-banner text-center">
      <img src="@/assets/images/check-mail.png" alt="" />
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-lg-6 col-xl-5 m-auto">
          <div class="account-form-block mt-5">
            <h2 class="text-center mb-3">{{ $t('confirmEmail') }}</h2>
            <p class="text-center mb-4">
              <!-- We sent an email with the activation link. Please click the link in this email to
              continue. After your email is confirmed, return to the StoryPhones app to continue. -->
              {{ $t('confirmEmailMsg') }}
            </p>

            <div class="text-center">
              <div class="wave-btn-block">
                <button
                  type="submit"
                  class="blob-btn fill-bg btn-lg submit-btn"
                  @click="goToLogin()"
                >
                  {{ $t('logIn') }}
                  <span class="blob-btn__inner">
                    <span class="blob-btn__blobs">
                      <span class="blob-btn__blob"></span>
                      <span class="blob-btn__blob"></span>
                      <span class="blob-btn__blob"></span>
                      <span class="blob-btn__blob"></span>
                    </span>
                  </span>
                </button>
                <SvgButton />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <PageFooter />
</template>

<script lang="js">
import {
  ref, computed,
} from 'vue';
import { useRouter } from 'vue-router';

import PageHeader from '@/components/commons/PageHeader.vue';
import PageFooter from '@/components/commons/PageFooter.vue';
import SvgButton from '@/components/partials/SvgButton.vue';

export default {
  name: 'confirm-email',
  props: [],
  components: {
    SvgButton,
    PageHeader,
    PageFooter,
  },
  setup() {
    const router = useRouter();

    const goToLogin = () => {
      router.push('/login');
    };

    return { goToLogin };
  },
};
</script>

<style scoped lang="scss"></style>
